// Generated by purs version 0.15.15
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_Clients from "../Ouroboros.Programs.Controllers.Clients/index.js";
var readState = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var buildClientsViewProps = function (input) {
    return {
        clients: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.clients)),
        projects: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.projects)),
        documents: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.documents)),
        activeClientId: readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.activeClientId)),
        activeProjectId: readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.activeProjectId)),
        newClientName: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.newClientName)),
        newProjectTitle: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.newProjectTitle)),
        isUploading: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.isUploading)),
        onNewClientNameChange: Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.newClientName)),
        onNewProjectTitleChange: Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.newProjectTitle)),
        onCreateClient: Ouroboros_Programs_Controllers_Clients.onCreateClient(input),
        onCreateProject: Ouroboros_Programs_Controllers_Clients.onCreateProject(input),
        onRenameProject: Ouroboros_Programs_Controllers_Clients.onRenameProject(input),
        onDeleteProject: Ouroboros_Programs_Controllers_Clients.onDeleteProject(input),
        onDeleteDocument: Ouroboros_Programs_Controllers_Clients.onDeleteDocument(input),
        onUploadDocuments: Ouroboros_Programs_Controllers_Clients.onUploadDocuments(input),
        onViewDocument: Ouroboros_Programs_Controllers_Clients.onViewDocument(input.kernel),
        onDownloadDocument: Ouroboros_Programs_Controllers_Clients.onDownloadDocument(input.kernel),
        onBackToClients: Ouroboros_Programs_Controllers_Clients.onBackToClients(input.kernel),
        onBackToProjects: Ouroboros_Programs_Controllers_Clients.onBackToProjects(input.kernel),
        onNavigateClient: Ouroboros_Programs_Controllers_Clients.onNavigateClient(input.kernel),
        onNavigateProject: Ouroboros_Programs_Controllers_Clients.onNavigateProject(input.kernel),
        onRouteClientChange: Ouroboros_Programs_Controllers_Clients.onRouteClientChange(input),
        onRouteProjectChange: Ouroboros_Programs_Controllers_Clients.onRouteProjectChange(input),
        onInit: Ouroboros_Programs_Controllers_Clients.buildOnInit(input.kernel)
    };
};
export {
    buildClientsViewProps
};
//# sourceMappingURL=index.js.map
